import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '@/features/Profile/SettingsLayout';

export const Route = createFileRoute('/admin/settings')({
  component: SettingsLayout,
});
